var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",class:{ selected: _vm.selected }},[_c('nice-label',{attrs:{"label":_vm.label}}),_c('div',{staticClass:"value",domProps:{"innerHTML":_vm._s(_vm.value)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }